import React, { Fragment, use, useEffect } from "react";
import { useNavigate } from "react-router";

import { LeftBorder } from "@/shared/components/LeftBorder";

import illustration from "@/assets/images/illustration-4.svg";
import illustration_employee from "@/assets/images/illustration-3.svg";

import * as m from "@/shared/styles/main.module.scss";
import { Survey, SurveyStatus } from "../types/valuebuilder";
import useSurveyStore from "../stores/surveyStore";

interface SuccessProps {}

const Success: React.FC<SuccessProps> = () => {
  const navigate = useNavigate();
  const data = useSurveyStore.use.survey();
  const isEmployee = useSurveyStore.use.isEmployee();
  const redirect = () => {
    window.location.href = data?.siteUrl || "";
  };

  useEffect(() => {
    if (!data?.confirmation) {
      navigate("/");
    }

    // VBA-7241 For the person that reported this issue some space appeared below the .container element, it was replicable by adding 1000px of padding-bottom to it
    // None of us could replicate it so we perform a scroll to the top of the page in the rare case this happens
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  return !data ? null : (
    <div className={m.wrapper}>
      <div className={m.start}>
        {data.status !== undefined && data.status === SurveyStatus.CLOSED ? (
          <div className={m.borderLabel}>
            <h1>
              <LeftBorder />
              {"This survey was closed."}
            </h1>
          </div>
        ) : (
          <Fragment>
            <div className={m.borderLabel}>
              <h1>
                <LeftBorder />
                {data.confirmation}
              </h1>
            </div>
            {data.siteUrl ? (
              <div className={m.navigateButton}>
                <button
                  className={`${m.btn} ${m.btnPrimary}`}
                  onClick={redirect}
                >
                  {data.siteLinkText || "Visit our site"}
                </button>
              </div>
            ) : null}
            <div className={m.centerImage}>
              <img
                src={isEmployee ? illustration_employee : illustration}
                alt="illustration"
              />
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};
export default Success;
